import { apiClient, unwrap } from './client';
import type { ApiEnvelope, PaymentInit, Tariff } from './types';

export async function listTariffs(): Promise<Tariff[]> {
  const { data } = await apiClient.get<ApiEnvelope<Tariff[]>>('/api/tariff/list');
  return unwrap(data);
}

export async function initPayment(
  userGUID: string,
  tariffId: number,
): Promise<PaymentInit> {
  const { data } = await apiClient.post<ApiEnvelope<PaymentInit>>(
    `/api/user/${userGUID}/payment/tariff/${tariffId}`,
  );
  return unwrap(data);
}
